import { PatchScript } from 'containers/Forms/Settings/views/Debug/components/ReceiptSchema/Editor/schema/comms';

// @TODO Need to either fix this type to actually represent payment in Redux or add a new type (similar to the one in Printing)
export type PaymentObj = {
  key: string;
  amount: string;
  typeID: string;
  vatrateID: string;
  giftCardBalance: string;
  added: string;
  cardHolder: string;
  giftCardID: string;
  serial: string;
  cardType?: string;
  cardNumber?: string;
  signature?: string;
  // Currency since this is what MS expects
  currency: string;
  shouldProcess?: boolean;
  needsConfirmation?: boolean;
  paid?: boolean;
  aid?: string;
  applicationLabel?: string;
  pinStatement?: string;
  cryptogramType?: string;
  cryptogram?: string;
  transactionId?: string;
  attributes?: {
    refNo?: string;
    authCode?: string;
    [other: string]: any;
  };
};

export type CardPaymentHooks = {
  displayWarning: (arg: string) => void;
  displayError: (arg: string) => void;
  displaySuccess: (arg: string) => void;
  updateMessage: (arg: string) => void;
  enabledButtons: string[];
  enableButtons: (arg: string[]) => void;
  resolvePayments: () => void;
  rejectPayments: () => void;
  setTitle: (arg: string) => void;
  cardPayments: any[];
  isCurrentSaleAReturn: boolean;
  isPartialReturn: boolean;
  beforeDocSave: (arg: {
    terminalResponse?: {
      brazilMeta?: {
        merchantPatchScript?: PatchScript;
        cardholderPatchScript?: PatchScript;
        brazilVersion?: string;
        integrationName?: string;
      };
      /** Full response from the provider/ms */
      originalResponse?: any;
    };
    [key: string]: any;
  }) => Promise<void>;
  beforeDocDelete: (arg: any) => void;
  formatCurrency: (arg: number) => void;
  currencyCode: string;
};

export const FUNC_BUTTONS = {
  RETRY: 'retry',
  VOID: 'void',
  CANCEL: 'cancel',
  REPRINT: 'reprint',
  RETURN_BACK: 'return-back',
  CHECK_STATUS: 'check-status',
  TERMINAL_DIAGNOSIS: 'terminal-diagnosis',
  CLOSE: 'close',
};
